/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const candidacyDetailDataSchema = z.object({
	id: z.string(),
	organisation: z.object({ id: z.string(), name: z.string() }),
	campaignTitle: z.string(),
	logoUrl: z.string().nullable(),
	thankYouTitle: z.string().nullable(),
	thankYouHtml: z.string().nullable(),
	submittedAt: z.iso.datetime(),
	submissionCount: z.number(),
	profileEditable: z.boolean(),
	collectsCv: z.boolean(),
	profile: z.object({
		name: z.string().nullable(),
		email: z.string().nullable(),
		phone: z.string().nullable(),
		canBeContacted: z.boolean(),
		cv: z.object({ id: z.string(), fileName: z.string(), sizeInBytes: z.number(), uploadedAt: z.iso.datetime() })
			.nullable(),
		workHistory: z.array(
			z.object({
				id: z.string(),
				contents: z.string(),
				createdAt: z.iso.datetime(),
				updatedAt: z.iso.datetime(),
			}),
		),
		education: z.array(
			z.object({
				id: z.string(),
				contents: z.string(),
				createdAt: z.iso.datetime(),
				updatedAt: z.iso.datetime(),
			}),
		),
		licenses: z.array(
			z.object({
				id: z.string(),
				contents: z.string(),
				createdAt: z.iso.datetime(),
				updatedAt: z.iso.datetime(),
			}),
		),
	}),
	answers: z.array(z.object({ question: z.string(), values: z.array(z.string()) })),
})

export type CandidacyDetailDataSchema = z.infer<typeof candidacyDetailDataSchema>
